import store from "@/store";

export default [
  {
    name: "UsersList",
    path: "/users-list",
    beforeEnter: (_to, _from, next) => {
      // Si esta verificado y tiene rango de Supervisor ++
      if (store.getters["auth/userWrite"]) {
        next();
        return;
        //Redirecciona al Dashboard
      } else next({ path: "/error" });
    }
  },
  {
    name: "UserProfile/BasicInformation",
    path: "/user-profile/basic-information"
  },
  {
    name: "UserProfile/Tasks",
    path: "/user-profile/tasks"
  },
  {
    path: "/user-profile",
    redirect: { name: "UserProfile/BasicInformation" }
  },
  {
    // Public Profile for users
    name: "PublicProfile",
    path: "/public-profile/:id"
  }
];
